<template>
    <div class='consultationRecordParentAdd'>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm content">
            <div class="lineBox">
                <CircleName name="主要问题描述" ></CircleName>
                <el-form-item  prop="mainProblem" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.mainProblem" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="lineBox">
                <CircleName name="咨询要点记录"></CircleName>
                <el-form-item  prop="consultantPoints" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.consultantPoints" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="lineBox">
                <CircleName name="建议解决对策"></CircleName>
                <el-form-item  prop="recommendSolution" class="elForm">
                    <el-input label=""  type="textarea" v-model="ruleForm.recommendSolution" placeholder="请填写"  :rows="4" ></el-input>
                </el-form-item>
            </div>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-form-item  prop="consultSummary">
                    <el-input  type="textarea" v-model="ruleForm.consultSummary" placeholder="请填写咨询总结"  :rows="5" ></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <!--<Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" name="预览" ></Button>-->
            <Button @handleClick="submitForm('ruleForm',false)" :type="'btnBlue'" name="保存" ></Button>
        </div>
        <InterviewPopup :interviewRecord="interviewRecord" :isInputReadOnly="isInputReadOnly"  isParentInterview="true"   v-on:closePop="()=>isShowPop=false" v-show="isShowPop"></InterviewPopup>
    </div>
</template>
<script>
import InterviewPopup from '@/components/consultant/InterviewPopup.vue';
import CircleName from '@/components/consultant/CircleName.vue';
import SummaryTitle from '@/components/consultant/SummaryTitle.vue';
import Button from '@/components/Button.vue';

export default {
    name: "consultationRecordStudentAdd",
    components: {
        Button,
        CircleName,
        SummaryTitle,
        InterviewPopup
    },
    data() {
        return {

            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            isShowPop:true,
            isInputReadOnly: false,
            //咨询记录
            interviewRecord: {
                category: 5,//类别：1首次访谈 2规划内容 3 目标拆分 4行动计划 5自由主题
                interviewTime: '',//时间
                interviewNum: '',//次数
                interviewTheme: '',//主题,
            },

            ruleForm: {
                mainProblem: '',//主要问题描述
                consultantPoints: '',//咨询要点记录
                recommendSolution: '',//建议解决方案
                consultSummary: '',//咨询总结
            },
            rules: {
                interviewTheme: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                mainProblem: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                consultantPoints: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                recommendSolution: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
                consultSummary: [
                    { required: true, message: '请填写', trigger: 'change' },
                ],
            }


        }
    },
    created() {

    },
    methods: {

        submitForm(formName) {
            console.log(this.ruleForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let freeTheme = this.ruleForm;
                    let interviewRecord= this.interviewRecord;
                    let studentId = this.studentId;
                    this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.storeParentInterviewFreeTheme, {
                        freeTheme,interviewRecord,studentId
                    }, {
                        headers: {
                            token: window.sessionStorage.getItem('ymtxToken')
                        }
                    }).then((res) => {
                        if (res.data.code == 2000) {
                            let id = res.data.data.id;
                            this.$router.replace({path:'/consultant/minestudent/main/consultationRecord/parent/detail',query:{id: id}})
                        }
                    })

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
}
</script>

<style scoped lang="less">
.consultationRecordParentAdd {
    .content {
        padding: 6px 30px 8px 30px;
        background-color: #fff;
        .elForm {
            padding-top: 16px;
        }
        .lineBox {
            margin-bottom: 32px;
        }
    }
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>
<style lang="less">
.consultationRecordParentAdd {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
}
</style>